import ClientAppService from '../../services/ClientAppService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'
export const namespaced = true

const initialState = {
  apps: [],
  selectedApp: {},
  selectedAppMenu: {}
}

export const state = {
  apps: [],
  selectedApp: {},
  selectedAppMenu: {}
}

export const mutations = {
  SET_APPS(state, recs) {
    state.apps = recs
  },
  SET_SELECTED_APP(state, rec) {
    state.selectedApp = rec
  },
  SET_SELECTED_APP_MENU(state, rec) {
    state.selectedAppMenu = rec
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  // v1
  fetchClientApps: async function(context) {
    localStorage.menuItemsTreeState = []
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    try {
      const r = await ClientAppService.getClientAppsForUser()
      context.commit('SET_APPS', r.data)
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    } catch (e) {
      context.commit('SET_APPS', [])
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(e, context, router)
    }
  },

  fetchClientAppsForProject: async function(context, value) {
    localStorage.menuItemsTreeState = []
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    try {
      const r = await ClientAppService.getClientAppsForProject(value)
      context.commit('SET_APPS', r.data)
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    } catch (e) {
      context.commit('SET_APPS', [])
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(e, context, router)
    }
  },

  // // v 2
  // fetchClientApps: function(context) {
  // 	localStorage.menuItemsTreeState = [];
  // 	context.commit("SET_LOADING_STATUS", "loading", { root: true });
  // 	return ClientAppService.getClientAppsForUser().then(
  // 		(r) => {
  // 			context.commit("SET_APPS", r.data);
  // 			context.commit("SET_LOADING_STATUS", "idle", { root: true });
  // 		},
  // 		(e) => {
  // 			context.commit("SET_APPS", []);
  // 			context.commit("SET_LOADING_STATUS", "idle", { root: true });
  // 			AxiosErrorHandler.handler(e, context, router);
  // 		}
  // 	);
  // },
  selectClientApp: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ClientAppService.getClientAppById(value).then(
      r => {
        // let data = r.data;
        // let menus = [];
        // // find root menus
        // // TODO transfer this to a helper module
        // for (let i = 0; i < data.length; i++) {
        // 	if (data[i].parentMenuItemId == null) {
        // 		menus.push(data[i]);
        // 	}
        // }
        context.commit('SET_SELECTED_APP', r.data)
        context.dispatch('ProjectStore/setSelectedProject', r.data.projectId, {
          root: true
        })
        ClientAppService.getRootMenus(value).then(
          r => {
            context.commit('SET_SELECTED_APP_MENU', r.data)
            context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          },
          e => {
            context.commit('SET_SELECTED_APP_MENU', null)
            context.commit('SET_LOADING_STATUS', 'idle', { root: true })
            AxiosErrorHandler.handler(e, context, router)
          }
        )
      },
      e => {
        context.commit('SET_SELECTED_APP', null)
        context.commit('SET_SELECTED_APP_MENU', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  updateClientApp: function(context, value) {
    ClientAppService.updateClientApp(value)
      .then(res => {
        context.dispatch(
          'NotificationStore/add',
          { type: 'info', message: 'Client app successfully updated' },
          { root: true }
        )
      })
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}

export const getters = {
  getSelectedClientAppId: state => {
    return state.selectedApp ? state.selectedApp.id : 0
  },
  getSelectedClientAppProjectId: state => {
    return state.selectedApp ? state.selectedApp.projectId : 0
  }
}
